import React from 'react'

import { SVGArrowRight, SVGUseWinter, SVGWalletConnect } from '@common/public/assets'
import { SVGMetamask } from '@common/public/images'
import { IWalletsLogosCreditCard } from '@types'

import UseWinter from './components/UseWinter'

import { PaymentMethodItem, RowContainer } from './styles'

interface IWalletProvider {
    paymentMethod: string
}

const walletsLogos: IWalletsLogosCreditCard = {
    crossmint: <SVGMetamask />,
    winter: <SVGUseWinter />,
    wert: <SVGWalletConnect />,
}

export const WalletWithCreditCard: React.FC<IWalletProvider> = ({ paymentMethod }) => {
    const [shouldShowWinter, setShouldShowWinter] = React.useState(false)

    const handleSelectPaymentMethodCreditCard = React.useCallback(() => {
        if (paymentMethod === 'winter') {
            setShouldShowWinter(true)
        }
    }, [])

    return (
        <>
            <PaymentMethodItem key={`payment-method-${paymentMethod}`}>
                <button className={paymentMethod} onClick={handleSelectPaymentMethodCreditCard} value={paymentMethod}>
                    <RowContainer>
                        {walletsLogos[paymentMethod]}
                        {paymentMethod}
                    </RowContainer>
                    <SVGArrowRight />
                </button>
            </PaymentMethodItem>
            {shouldShowWinter && <UseWinter showWinter={shouldShowWinter} setShowWinter={setShouldShowWinter} />}
        </>
    )
}
